(function () {
  'use strict';

  var TRIGGER_START = 'top 88%';
  var MOBILE_MAX_DURATION = 0.55;
  var STAGGER_OPTS = { each: 0.08 };

  function getIsMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function getEase(gsap) {
    if (window.CustomEase) {
      gsap.registerPlugin(window.ScrollTrigger, window.CustomEase);

      if (!gsap.parseEase('framerReveal')) {
        window.CustomEase.create('framerReveal', 'M0,0 C0.12,0.23 0.17,0.99 1,1');
      }

      return 'framerReveal';
    }

    gsap.registerPlugin(window.ScrollTrigger);
    return 'power3.out';
  }

  function getPresets(ease) {
    return {
      default: {
        from: { autoAlpha: 0, y: 40 },
        to:   { autoAlpha: 1, y: 0, duration: 0.82, ease: ease }
      },
      image: {
        from: { autoAlpha: 0, y: 40 },
        to:   { autoAlpha: 1, y: 0, duration: 0.9, ease: ease }
      },
      badge: {
        from: { autoAlpha: 0, y: 28, scale: 0.98, rotation: -1 },
        to:   { autoAlpha: 1, y: 0, scale: 1, rotation: 0, duration: 0.72, ease: ease }
      }
    };
  }

  function getPreset(el, presets) {
    var val = el.getAttribute('data-reveal') || 'default';
    return presets[val] || presets.default;
  }

  function clone(obj) {
    var out = {};
    for (var k in obj) out[k] = obj[k];
    return out;
  }

  function getNumberAttr(el, attr, fallback) {
    var val = parseFloat(el.getAttribute(attr));
    return isNaN(val) ? fallback : val;
  }

  function buildTo(el, preset, gsapRef) {
    var to = clone(preset.to);

    if (getIsMobile() && to.duration > MOBILE_MAX_DURATION) {
      to.duration = MOBILE_MAX_DURATION;
    }

    to.delay = getNumberAttr(el, 'data-reveal-delay', 0);
    to.y = getNumberAttr(el, 'data-reveal-to-y', to.y || 0);
    to.autoAlpha = getNumberAttr(el, 'data-reveal-opacity', to.autoAlpha || 1);

    to.onComplete = function () {
      el.removeAttribute('data-reveal');
      gsapRef.set(el, { clearProps: 'opacity,visibility,transform,will-change' });
    };

    return to;
  }

  function showAll(scope) {
    scope.querySelectorAll('[data-reveal], [data-reveal-stagger] > *').forEach(function (el) {
      el.style.opacity = '1';
      el.style.visibility = 'visible';
      el.style.transform = 'none';
      el.style.willChange = 'auto';
    });

    scope.querySelectorAll('[data-reveal]').forEach(function (el) {
      el.removeAttribute('data-reveal');
    });

    scope.querySelectorAll('[data-reveal-stagger]').forEach(function (el) {
      el.removeAttribute('data-reveal-stagger');
    });
  }

  function initReveals(scope) {
    var gsap = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;
    if (!gsap || !ScrollTrigger) return;

    var ease = getEase(gsap);
    var PRESETS = getPresets(ease);

    scope.querySelectorAll('[data-reveal]').forEach(function (el) {
      if (el.closest('[data-reveal-stagger]')) return;
      if (el.dataset.revealBound) return;

      el.dataset.revealBound = '1';

      var preset = getPreset(el, PRESETS);
      var from = clone(preset.from);
      var to = buildTo(el, preset, gsap);

      gsap.set(el, from);

      gsap.to(el, Object.assign({}, to, {
        overwrite: 'auto',
        scrollTrigger: {
          trigger: el,
          start: el.getAttribute('data-reveal-start') || TRIGGER_START,
          once: true,
          onEnter: function() {
            gsap.set(el, { clearProps: 'will-change' });
          }
        }
      }));
    });

    scope.querySelectorAll('[data-reveal-stagger]').forEach(function (group) {
      if (group.dataset.revealBound) return;

      group.dataset.revealBound = '1';

      var children = Array.prototype.slice.call(group.children);
      if (!children.length) return;

      var presetName = group.getAttribute('data-reveal-stagger') || 'default';
      var preset = PRESETS[presetName] || PRESETS.default;

      children.forEach(function (child) {
        gsap.set(child, preset.from);
      });

      var to = clone(preset.to);

      if (getIsMobile() && to.duration > MOBILE_MAX_DURATION) {
        to.duration = MOBILE_MAX_DURATION;
      }

      to.stagger = Object.assign({}, STAGGER_OPTS, {
        each: getNumberAttr(group, 'data-reveal-stagger-each', STAGGER_OPTS.each)
      });

      to.onComplete = function () {
        group.removeAttribute('data-reveal-stagger');
        gsap.set(children, { clearProps: 'opacity,visibility,transform,will-change' });
      };

      gsap.to(children, Object.assign({}, to, {
        overwrite: 'auto',
        scrollTrigger: {
          trigger: group,
          start: group.getAttribute('data-reveal-start') || TRIGGER_START,
          once: true
        }
      }));
    });

    ScrollTrigger.refresh();
  }

    function boot(scope) {
    var root = scope || document;
    var hasTargets = root.querySelector('[data-reveal]') || root.querySelector('[data-reveal-stagger]');
    if (!hasTargets) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      showAll(root);
      return;
    }



    if (typeof window.ensureGsapDeps === 'function') {
      window.ensureGsapDeps()
        .then(function () { 
          initReveals(root); 
        })
        .catch(function () { 
          showAll(root); 
        });
      return;
    }

    if (window.gsap && window.ScrollTrigger) {
      initReveals(root);
    } else {
      showAll(root);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    boot(document);
  });


  window.addEventListener('load', function () {
    if (window.ScrollTrigger) {
      window.ScrollTrigger.refresh();
      // Secondary refresh to catch any deeply nested lazy loaded apps
      setTimeout(function() { window.ScrollTrigger.refresh(); }, 1500);
    }
  });


  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      boot(e.target);
    });
  }
})();